import "./index.scss";
import { useState, useRef, useEffect } from "react";
import {
  Select,
  Input,
  Button,
  message,
  Table,
  Pagination,
  Tooltip,
  Drawer,
  Space,
  Form,
  Empty,
  Typography,
} from "antd";
import emptyImg from "../../assets/暂无icon.png";
import MessageModal from "../../components/MessageModal";
import { useDebounce, useGetState, useSize, useUnmount } from "ahooks";
import Api from "../../apis/index";
import { CheckCircleFilled, CloseOutlined, EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
const { Paragraph } = Typography;

function PasswordText(props) {
  const { info } = props;
  const [visible, setVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleToggle = async (e) => {
    e.stopPropagation();
    if (visible) {
      setVisible(false);
      setPassword("");
    } else {
      if (password) {
        setVisible(true);
      } else {
        setLoading(true);
        try {
          const res = await Api.getAccountPassword(info.id);
          if (res.code === 200) {
            setPassword(res.data?.password || "");
            setVisible(true);
          } else {
            message.error("获取密码失败");
          }
        } catch (err) {
          message.error("获取密码失败");
        } finally {
          setLoading(false);
        }
      }
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <span>{visible ? password : info?.password_mask}</span>
      <span
        onClick={handleToggle}
        style={{ marginLeft: 8, cursor: "pointer", display: "flex", alignItems: "center" }}
      >
        {loading ? (
          <span style={{ width: 14, height: 14, display: "inline-block" }} />
        ) : visible ? (
          <EyeInvisibleOutlined style={{ fontSize: 14 }} />
        ) : (
          <EyeOutlined style={{ fontSize: 14 }} />
        )}
      </span>
    </div>
  );
}

function AccountManagement() {
  const contentRef = useRef(null);

  const [data, setData, getData] = useGetState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber, getPageNumber] = useGetState(1);
  const [activeItem, setActiveItem] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false); //抽屉是否打开
  const [accountWebsiteOptions, setAccountWebsiteOptions] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [form] = Form.useForm();
  const [upLoading, setUpLoading, getUpLoading] = useGetState(false);
  const [isOk, setIsOk] = useState(false);

  const size = useSize(contentRef);

  //操作按扭点击回调
  const handleFunc = async (type, record) => {
    setActiveItem(record);
    if (type === "编辑") {
      const res = await Api.getAccountPassword(record.id);
      if (res.code !== 200) {
        message.error("编辑失败");
        return;
      }
      setAccountWebsiteOptions([
        {
          value: record.web_id,
          label: record.web_name,
        },
      ]);
      let obj = {
        web: record.web_id,
        account: record.account,
        password: res?.data?.password,
      };
      setIsOk(false);
      setIsEdit(true);
      form.setFieldsValue(obj);
      setDrawerOpen(true);
    } else if (type === "删除") {
      MessageModal({
        type: "warning",
        description: `确定要${type}此账号吗？`,
        title: "提醒",
        onOk: () => {
          Api.deleteAccount(record.id).then((res) => {
            if (res.code === 200) {
              getDataFunc();
              message.success(res.message);
            } else {
              message.error(res.message);
            }
          });
        },
      });
    }
  };

  const columns = useRef([
    {
      title: "序号",
      dataIndex: "index",
      align: "center",
      width: 60,
      render: (_, __, index) =>
        getPageNumber() * pageSize - pageSize + index + 1,
    },
    {
      title: "网站名称",
      dataIndex: "web_name",
      align: "center",
      minWidth: 200,
      render: (_) => (
        <Paragraph ellipsis={{ rows: 3, tooltip: _ }}>{_}</Paragraph>
      ),
    },
    {
      title: "账号/手机号",
      dataIndex: "account",
      align: "center",
      width: 140,
    },
    {
      title: "密码",
      dataIndex: "password_mask",
      align: "center",
      minWidth: 120,
      render: (_, record) => (
        <PasswordText info={record}></PasswordText>
      ),
    },
    {
      title: "操作",
      dataIndex: "操作",
      width: 100,
      render: (_, record) => (
        <span
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Tooltip title="编辑">
            <svg
              fill="none"
              className="tableIcon"
              version="1.1"
              width="16.80810546875"
              height="16.80810546875"
              viewBox="0 0 16.80810546875 16.80810546875"
              onClick={(e) => {
                e.stopPropagation();
                handleFunc("编辑", record);
              }}
            >
              <g>
                <g>
                  <path
                    d="M9.861374185180665,11.2499078125L14.411574185180664,6.6997478125L14.418364185180664,6.6929578125L16.375024185180663,4.6069278125Q16.818224185180664,4.1344478124999995,16.807824185180664,3.4867378125Q16.797424185180667,2.8390178125,16.339424185180665,2.3809578125L14.427024185180665,0.4685868125Q13.968964185180663,0.010521812500000005,13.321244185180664,0.00016181249999999703Q12.673524185180664,-0.01019718750000001,12.201044185180663,0.4329838125L10.111004185180665,2.3934278125L5.678747185180664,6.9921178125Q5.394808185180664,7.2867278125,5.287151185180664,7.6814678125L4.567226185180664,10.3212078125Q4.327469185180664,11.2003078125,4.961237185180664,11.8550078125Q5.595003185180664,12.5097078125,6.481434185180664,12.2987078125L9.100594185180665,11.6751078125Q9.541144185180663,11.5702078125,9.861374185180665,11.2499078125ZM13.138784185180665,6.2754878125L9.012844185180665,10.4014078125Q8.932784185180665,10.4815078125,8.822644185180664,10.5077078125L6.203494185180664,11.1313078125Q5.981884185180665,11.1841078125,5.823444185180664,11.0204078125Q5.665003185180664,10.8567078125,5.724944185180664,10.6369078125L6.4448641851806645,7.9972078125Q6.471784185180664,7.8985178125,6.542764185180664,7.8248678125L10.540404185180664,3.6771178125L13.138784185180665,6.2754878125ZM11.394834185180663,2.8344878125L13.022004185180664,1.3082178125Q13.304564185180665,1.0431778125,13.578504185180664,1.3171178125L15.490824185180664,3.2294878125Q15.764824185180665,3.5034178125,15.499824185180664,3.7859778125L13.973514185180663,5.4131578125L11.394834185180663,2.8344878125Z"
                    fill-rule="evenodd"
                    fill="#535353"
                    fill-opacity="1"
                  />
                </g>
                <g>
                  <path
                    d="M7.0777155859375,2.9888444900512696Q7.1368155859375,2.9888444900512696,7.1947755859375,2.9773154900512697Q7.2527255859375,2.9657864900512694,7.3073255859375,2.9431724900512695Q7.3619255859375,2.9205574900512694,7.4110555859375,2.8877264900512696Q7.4601955859375,2.8548944900512696,7.5019855859375,2.8131084900512695Q7.5437655859375,2.7713224900512694,7.5765955859375,2.7221864900512696Q7.6094255859375,2.6730514900512694,7.6320455859375,2.6184544900512696Q7.6546555859375,2.5638584900512695,7.6661855859375,2.5058984900512695Q7.6777155859375,2.4479392900512695,7.6777155859375,2.3888444900512695Q7.6777155859375,2.3297496900512695,7.6661855859375,2.2717904900512695Q7.6546555859375,2.2138304900512695,7.6320455859375,2.1592344900512694Q7.6094255859375,2.1046374900512697,7.5765955859375,2.0555024900512695Q7.5437655859375,2.0063664900512697,7.5019855859375,1.9645804900512696Q7.4601955859375,1.9227944900512695,7.4110555859375,1.8899624900512695Q7.3619255859375,1.8571314900512697,7.3073255859375,1.8345164900512696Q7.2527255859375,1.8119024900512697,7.1947755859375,1.8003734900512696Q7.1368155859375,1.7888444900512694,7.0777155859375,1.7888444900512694L7.0774455859375,1.7888444900512694L0.5999755859375,1.7888444900512694Q0.5408807859375,1.7888444900512694,0.4829215859375,1.8003734900512696Q0.4249615859375,1.8119024900512697,0.3703655859375,1.8345164900512696Q0.3157685859375,1.8571314900512697,0.2666335859375,1.8899624900512695Q0.21749758593750002,1.9227944900512695,0.17571158593750003,1.9645804900512696Q0.13392558593749998,2.0063664900512697,0.10109358593750001,2.0555024900512695Q0.06826258593750001,2.1046374900512697,0.04564758593749996,2.1592344900512694Q0.023033585937500045,2.2138304900512695,0.011504585937500034,2.2717904900512695Q-0.000024414062499977796,2.3297496900512695,-0.000024414062499977796,2.3888444900512695L-0.000024414062499977796,16.20804449005127Q-0.000024414062499977796,16.26714449005127,0.011504585937500034,16.32504449005127Q0.023033585937500045,16.38304449005127,0.04564758593749996,16.43764449005127Q0.06826258593750001,16.49224449005127,0.10109358593750001,16.54134449005127Q0.13392558593749998,16.59044449005127,0.17571158593750003,16.63224449005127Q0.21749758593750002,16.67404449005127,0.2666335859375,16.706844490051267Q0.3157685859375,16.73974449005127,0.3703655859375,16.76234449005127Q0.4249615859375,16.78494449005127,0.4829215859375,16.79644449005127Q0.5408807859375,16.80804449005127,0.5999755859375,16.80804449005127L14.8509755859375,16.80804449005127Q14.9100755859375,16.80804449005127,14.9680755859375,16.79644449005127Q15.0259755859375,16.78494449005127,15.0805755859375,16.76234449005127Q15.1351755859375,16.73974449005127,15.1843755859375,16.706844490051267Q15.2334755859375,16.67404449005127,15.2752755859375,16.63224449005127Q15.3170755859375,16.59044449005127,15.3498755859375,16.54134449005127Q15.3826755859375,16.49224449005127,15.4053755859375,16.43764449005127Q15.4279755859375,16.38304449005127,15.4394755859375,16.32504449005127Q15.4509755859375,16.26714449005127,15.4509755859375,16.20804449005127L15.4509755859375,9.29842449005127Q15.4509755859375,9.23933449005127,15.4394755859375,9.181374490051269Q15.4279755859375,9.12341449005127,15.4053755859375,9.06881449005127Q15.3826755859375,9.01421449005127,15.3498755859375,8.96508449005127Q15.3170755859375,8.91594449005127,15.2752755859375,8.87416449005127Q15.2334755859375,8.832374490051269,15.1843755859375,8.79954449005127Q15.1351755859375,8.76671449005127,15.0805755859375,8.74409449005127Q15.0259755859375,8.72148449005127,14.9680755859375,8.70995449005127Q14.9100755859375,8.69842449005127,14.8509755859375,8.69842449005127Q14.7918755859375,8.69842449005127,14.7339755859375,8.70995449005127Q14.6759755859375,8.72148449005127,14.6213755859375,8.74409449005127Q14.5667755859375,8.76671449005127,14.5176755859375,8.79954449005127Q14.4685755859375,8.832374490051269,14.4267755859375,8.87416449005127Q14.3849755859375,8.91594449005127,14.3520755859375,8.96508449005127Q14.3192755859375,9.01421449005127,14.2966755859375,9.06881449005127Q14.2740755859375,9.12341449005127,14.2625755859375,9.181374490051269Q14.2509755859375,9.23933449005127,14.2509755859375,9.29842449005127L14.2509755859375,15.60804449005127L1.1999755859375,15.60804449005127L1.1999755859375,2.9888444900512696L7.0777155859375,2.9888444900512696L7.0777155859375,2.9888444900512696Z"
                    fill-rule="evenodd"
                    fill="#535353"
                    fill-opacity="1"
                  />
                </g>
              </g>
            </svg>
          </Tooltip>

          <Tooltip title="删除">
            <svg
              className="tableIcon"
              fill="none"
              version="1.1"
              width="15.14990234375"
              height="16.14990234375"
              viewBox="0 0 15.14990234375 16.14990234375"
              onClick={(e) => {
                e.stopPropagation();
                handleFunc("删除", record);
              }}
            >
              <g>
                <g>
                  <path
                    d="M9.847077466125487,13.534786463165283L9.847077466125487,5.638324463165283C9.847077466125487,5.352412463165283,9.619367466125489,5.120636463165283,9.338487466125489,5.120636463165283C9.057597466125488,5.120636463165283,8.829897466125487,5.352412463165283,8.829897466125487,5.638324463165283L8.829897466125487,13.534786463165283C8.829897466125487,13.820696463165284,9.057597466125488,14.052476463165283,9.338487466125489,14.052476463165283C9.619367466125489,14.052476463165283,9.847077466125487,13.820696463165284,9.847077466125487,13.534786463165283ZM6.273387466125488,13.534786463165283L6.273387466125488,5.638324463165283C6.273387466125488,5.352412463165283,6.045683466125488,5.120636463165283,5.764797466125488,5.120636463165283C5.483910466125488,5.120636463165283,5.256207466125488,5.352412463165283,5.256207466125488,5.638324463165283L5.256207466125488,13.534786463165283C5.256207466125488,13.820696463165284,5.483910466125488,14.052476463165283,5.764797466125488,14.052476463165283C6.045683466125488,14.052476463165283,6.273387466125488,13.820696463165284,6.273387466125488,13.534786463165283Z"
                    fill="#535353"
                    fill-opacity="1"
                  />
                  <path
                    d="M5.351668966125488,13.953406463165283Q5.522675466125488,14.127476463165284,5.764797466125488,14.127476463165284Q6.006918466125488,14.127476463165284,6.1779254661254885,13.953406463165283Q6.348387466125488,13.779896463165283,6.348387466125488,13.534786463165283L6.348387466125488,5.638324463165283Q6.348387466125488,5.393213463165283,6.1779254661254885,5.219702763165283Q6.006917466125488,5.045636463165283,5.764797466125488,5.045636463165283Q5.522676466125488,5.045636463165283,5.3516687661254885,5.219702763165283Q5.181207466125488,5.393213463165283,5.181207466125488,5.638324463165283L5.181207466125488,13.534786463165283Q5.181207466125488,13.779896463165283,5.351668966125488,13.953406463165283ZM8.925357466125488,13.953406463165283Q9.09636746612549,14.127476463165284,9.338487466125489,14.127476463165284Q9.580607466125489,14.127466463165284,9.751617466125488,13.953406463165283Q9.922077466125488,13.779896463165283,9.922077466125488,13.534786463165283L9.922077466125488,5.638324463165283Q9.922077466125488,5.393212463165283,9.751617466125488,5.219702763165283Q9.580607466125489,5.045636463165283,9.338487466125489,5.045636463165283Q9.09636746612549,5.045636463165283,8.925357466125488,5.219702763165283Q8.754897466125488,5.393213463165283,8.754897466125488,5.638324463165283L8.754897466125488,13.534786463165283Q8.754897466125488,13.779896463165283,8.925357466125488,13.953406463165283ZM6.070923466125488,13.848286463165284Q5.944005466125488,13.977476463165283,5.764797466125488,13.977476463165283Q5.585588466125488,13.977476463165283,5.458670466125488,13.848286463165284Q5.3312074661254885,13.718536463165282,5.3312074661254885,13.534786463165283L5.3312074661254885,5.638324463165283Q5.3312074661254885,5.454568463165283,5.458670466125488,5.3248244631652835Q5.585588466125488,5.195636463165283,5.764797466125488,5.195636463165283Q5.944005466125488,5.195636463165283,6.070923466125488,5.3248244631652835Q6.198386466125489,5.454568463165283,6.198386466125489,5.638324463165283L6.198386466125489,13.534786463165283Q6.198386466125489,13.718536463165282,6.070923466125488,13.848286463165284ZM9.644607466125489,13.848286463165284Q9.517697466125489,13.977476463165283,9.338487466125489,13.977476463165283Q9.159277466125488,13.977476463165283,9.032357466125488,13.848286463165284Q8.904897466125488,13.718546463165284,8.904897466125488,13.534786463165283L8.904897466125488,5.638323463165284Q8.904897466125488,5.454568463165283,9.032357466125488,5.3248244631652835Q9.159277466125488,5.195636463165283,9.338487466125489,5.195636463165283Q9.517697466125489,5.195636463165283,9.644607466125489,5.3248244631652835Q9.772077466125488,5.454567463165283,9.772077466125488,5.638324463165283L9.772077466125488,13.534786463165283Q9.772077466125488,13.718546463165284,9.644607466125489,13.848286463165284Z"
                    fill-rule="evenodd"
                    fill="#535353"
                    fill-opacity="1"
                  />
                </g>
                <g>
                  <path
                    d="M6.442491171875,1.110331171875L8.714191171875,1.110331171875C8.995081171875,1.110331171875,9.222781171875,0.878550171875,9.222781171875,0.592639171875C9.222781171875,0.306728171875,8.995081171875,0.0749511323786,8.714191171875,0.074951171875L6.442491171875,0.074951171875C6.161601171875,0.0749511323786,5.933901171875,0.306728171875,5.933901171875,0.592639171875C5.933901171875,0.878550171875,6.161601171875,1.110331171875,6.442491171875,1.110331171875ZM14.566351171875,1.911021171875L0.583541171875,1.911021171875C0.302654171875,1.911021171875,0.074951171875,2.142791171875,0.074951171875,2.428701171875C0.074951171875,2.714611171875,0.302654171875,2.946391171875,0.583541171875,2.946391171875L14.566351171875,2.946391171875C14.847251171875,2.946391171875,15.074951171875,2.714611171875,15.074951171875,2.428701171875C15.074951171875,2.142791171875,14.847251171875,1.911021171875,14.566351171875,1.911021171875M13.210151171875,3.912741171875C12.929251171875,3.912741171875,12.701551171875,4.144521171875,12.701551171875,4.430431171875L12.701551171875,15.039551171875L2.448371171875,15.039551171875L2.448371171875,4.430431171875C2.448371171875,4.144521171875,2.220661171875,3.912741171875,1.939781171875,3.912741171875C1.658891171875,3.912741171875,1.431191171875,4.144521171875,1.431191171875,4.430431171875L1.431191171875,15.557251171875C1.431191171875,15.843151171875,1.658891171875,16.074951171875,1.939781171875,16.074951171875L13.210151171875,16.074951171875C13.491051171875,16.074951171875,13.718751171875,15.843151171875,13.718751171875,15.557251171875L13.718751171875,4.430431171875C13.718751171875,4.144521171875,13.491051171875,3.912741171875,13.210151171875,3.912741171875Z"
                    fill="#535353"
                    fill-opacity="1"
                  />
                  <path
                    d="M6.029361171875,0.174017571875Q5.858901171875,0.347528171875,5.858901171875,0.592639171875Q5.858901171875,0.837749171875,6.029361171875,1.011260171875Q6.200371171875,1.185331171875,6.442491171875,1.185331171875L8.714191171875,1.185331171875Q8.956311171875,1.185331171875,9.127321171875,1.011260171875Q9.297781171875,0.837748171875,9.297781171875,0.592639171875Q9.297781171875,0.347529171875,9.127321171875,0.174017571875Q8.956311171875,-0.000048828124999997224,8.714191171875,-0.000048828124999997224L6.442491171875,-0.000048828124999997224Q6.200371171875,-0.000048828124999997224,6.029361171875,0.174017571875ZM6.136371171875,0.906138171875Q6.008901171875,0.776395171875,6.008901171875,0.592639171875Q6.008901171875,0.408883171875,6.136371171875,0.27913917187500004Q6.263281171875,0.149951171875,6.442491171875,0.149951171875L8.714191171875,0.149951171875Q8.893401171875,0.149951171875,9.020321171875,0.27913917187500004Q9.147781171875,0.408884171875,9.147781171875,0.592639171875Q9.147781171875,0.776394171875,9.020321171875,0.906138171875Q8.893401171875,1.0353271718750001,8.714191171875,1.035326171875L6.442491171875,1.0353271718750001Q6.263281171875,1.0353271718750001,6.136371171875,0.906138171875ZM14.979451171875,2.010081171875Q14.808451171875,1.836021171875,14.566351171875,1.836021171875L0.583540171875,1.836021171875Q0.341419171875,1.836021171875,0.170412471875,2.010081171875Q-0.000048828124999997224,2.183591171875,-0.000048828124999997224,2.428701171875Q-0.000048828124999997224,2.673811171875,0.170412571875,2.847331171875Q0.341420171875,3.021391171875,0.583541171875,3.021391171875L14.566351171875,3.021391171875Q14.808451171875,3.021391171875,14.979451171875,2.847331171875Q15.149951171875,2.673811171875,15.149951171875,2.428701171875Q15.149951171875,2.183601171875,14.979451171875,2.010081171875ZM0.583541171875,1.986021171875L14.566351171875,1.986021171875Q14.745551171875,1.986021171875,14.872451171875,2.115201171875Q14.999951171875,2.244951171875,14.999951171875,2.428701171875Q14.999951171875,2.612461171875,14.872451171875,2.742201171875Q14.745551171875,2.871391171875,14.566351171875,2.871391171875L0.583541171875,2.871391171875Q0.404332171875,2.871391171875,0.277414171875,2.742201171875Q0.149951171875,2.612461171875,0.149951171875,2.428701171875Q0.149951171875,2.244951171875,0.277414171875,2.115201171875Q0.404332171875,1.986021171875,0.583541171875,1.986021171875ZM13.793751171875,15.557251171875L13.793751171875,4.430431171875Q13.793751171875,4.185321171875,13.623251171875,4.011811171874999Q13.452251171875,3.837741171875,13.210151171875,3.837741171875Q12.968051171875,3.837741171875,12.796951171875,4.011811171874999Q12.626551171875,4.185321171875,12.626551171875,4.430431171875L12.626551171875,14.964551171875L2.523371171875,14.964551171875L2.523371171875,4.430431171875Q2.523371171875,4.185321171875,2.352911171875,4.011811171874999Q2.181901171875,3.837741171875,1.939781171875,3.837741171875Q1.697661171875,3.837741171875,1.526651171875,4.011811171874999Q1.356191171875,4.185321171875,1.356191171875,4.430431171875L1.356191171875,15.557251171875Q1.356191171875,15.802351171875,1.526651171875,15.975851171875Q1.697661171875,16.149951171875,1.939781171875,16.149951171875L13.210151171875,16.149951171875Q13.452251171875,16.149951171875,13.623251171875,15.975851171875Q13.793751171875,15.802351171875,13.793751171875,15.557251171875ZM13.516251171875,4.116931171875Q13.643751171875,4.246671171875,13.643751171875,4.430431171875L13.643751171875,15.557251171875Q13.643751171875,15.741051171875,13.516251171875,15.870751171875Q13.389351171875,15.999951171875,13.210151171875,15.999951171875L1.939781171875,15.999951171875Q1.760571171875,15.999951171875,1.633651171875,15.870751171875Q1.506191171875,15.741051171875,1.506191171875,15.557251171875L1.506191171875,4.430431171875Q1.506191171875,4.246671171875,1.633651171875,4.116931171875Q1.760571171875,3.987741171875,1.939781171875,3.987741171875Q2.118991171875,3.987741171875,2.245901171875,4.116931171875Q2.373371171875,4.246671171875,2.373371171875,4.430431171875L2.373371171875,15.114551171875L12.776551171875,15.114551171875L12.776551171875,4.430431171875Q12.776551171875,4.246671171875,12.903951171875,4.116931171875Q13.030951171875,3.987741171875,13.210151171875,3.987741171875Q13.389351171875,3.987741171875,13.516251171875,4.116931171875Z"
                    fill-rule="evenodd"
                    fill="#535353"
                    fill-opacity="1"
                  />
                </g>
              </g>
            </svg>
          </Tooltip>
        </span>
      ),
    },
  ]);

  //获取数据
  const getDataFunc = () => {
    setLoading(true);
    let params = {};
    params = {
      page_size: pageSize,
      page: getPageNumber(),
    };

    Api.getAccountList(params)
      .then((res) => {
        if (res.code === 200) {
          if ((res.data.data || []).length === 0 && res.data.total > 0) {
            let page = getPageNumber() - 1;
            pageChange(page >= 1 ? page : 1);
            return;
          }
          setData(res.data.data || []);
          setTotal(res.data.total || 0);
        } else {
          setData([]);
          setTotal(0);
          message.error(res.message);
        }
        setLoading(false);
      })
      .catch((sea) => {
        setLoading(false);
      });
  };

  //页码变化
  const pageChange = (page) => {
    setPageNumber(page);
    setTimeout(() => {
      getDataFunc();
    }, 100);
  };

  //获取可选网站列表
  const getAccountWebsiteOptions = () => {
    Api.getAccountWebsiteOptions().then((res) => {
      if (res.code === 200) {
        const options = (res.data || []).map((item) => ({
          value: item.id,
          label: item.web_name,
        }));
        setAccountWebsiteOptions(options);
      } else {
        message.error(res.message);
      }
    });
  };

  //抽屉关闭
  const drawerClose = () => {
    form.resetFields();
    setDrawerOpen(false);
  };

  //抽屉保存
  const onFinish = () => {
    if (getUpLoading()) {
      return;
    }
    // form.setFieldsValue(obj);
    form
      .validateFields()
      .then((res) => {
        setUpLoading(true);
        let params = {
          web_id: res.web,
          account: res.account,
          password: res.password,
        };
        if (isEdit) {
          params.id = activeItem.id;
        }
        Api.saveAccount(params).then((res) => {
          if (res.code === 200) {
            drawerClose();
            getDataFunc();
            message.success(res.message);
          } else {
            message.error(res.message);
          }
          setUpLoading(false);
        });
      })
      .catch((err) => {
        console.error(err);
        setUpLoading(false);
      });
  };

  //验证
  const onVerification = () => {
    if (getUpLoading()) {
      return;
    }
    if(isOk){
      return
    }
    form.validateFields().then((res) => {
      setUpLoading(true);

      Api.verifyAccountPassword({
        web_id: res.web,
        account: res.account,
        password: res.password,
      })
        .then((res) => {
          console.log(res);

          if (res.code === 200 && res.data.verify_pass) {
            setIsOk(true);
            message.success(res.message)
          } else {
            message.warning('验证失败，请检查账号和密码')
          }
          setUpLoading(false);
        })
        .catch((sea) => {
          setUpLoading(false);
        });
    });
  };

  useEffect(() => {
    getDataFunc();
  }, []);

  return (
    <div className="accountManagement" ref={contentRef}>
      <div class="headerTitleContent">
        <div class="left">
          <span class="block"></span>
          <div class="title">
            <div class="commentsHeaderTitleBox">账号管理</div>
          </div>
        </div>
        <div class="right"> </div>
      </div>
      <div className="content">
        <div className="infoContent">
          <div className="inputsBox">
            <span className="tipBox">
              由于部分网站设有限制访问，需完成实名认证方可进行核查，为确保核查任务顺利完成，请您提供该网站的账号和密码。若未能提供，我们可能无法完成此项核查
            </span>
            <div className="inputItemBox">
              <Button
                type="primary"
                onClick={() => {
                  getAccountWebsiteOptions();
                  setIsEdit(false);
                  setIsOk(false);
                  setDrawerOpen(true);
                }}
              >
                添加账号
              </Button>
            </div>
          </div>
          <div className="tableContainer">
            <Table
              className="myFormTable"
              locale={{
                emptyText: (
                  <Empty image={emptyImg} description="暂无数据"></Empty>
                ),
              }}
              loading={loading}
              bordered={true}
              pagination={false}
              scroll={{
                y: (size?.height || 0) - 280 + (total > 10 ? 40 : 0),
              }}
              rowKey="id"
              columns={columns.current}
              dataSource={data}
            />
            {total > 10 && (
              <div className="paginationBox">
                <Pagination
                  onChange={pageChange}
                  className="myPagination"
                  pageSize={pageSize}
                  current={pageNumber}
                  total={total}
                  showTotal={(total) => `共 ${total} 条`}
                  showSizeChanger={false}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <Drawer
        title={isEdit ? "编辑账号" : "新增账号"}
        width={600}
        closable={false}
        onClose={drawerClose}
        open={drawerOpen}
        className="myDrawer WebDrawer"
        extra={<CloseOutlined onClick={drawerClose} />}
        footer={
          <Space size="middle" align="center" direction="horizontal">
            <Button onClick={drawerClose}>取消</Button>
            <Button
              color={isOk ? "green" : "primary"}
              variant="solid"
              icon={isOk ? <CheckCircleFilled /> : null}
              loading={upLoading}
              onClick={onVerification}
            >
              验证{isOk ? "通过" : "账号"}
            </Button>
            {isOk ? (
              <Button type="primary" loading={upLoading} onClick={onFinish}>
                保存
              </Button>
            ) : (
              <Tooltip title="请先验证账号后再添加">
                <Button type="primary" disabled={true}>
                  保存
                </Button>
              </Tooltip>
            )}
          </Space>
        }
      >
        <Form
          name="layout-multiple-horizontal"
          layout="horizontal"
          form={form}
          onValuesChange={() => {
            setIsOk(false);
          }}
        >
          <Form.Item
            layout="vertical"
            label="网站"
            name="web"
            rules={[{ required: true }]}
          >
            <Select
              placeholder={`请选择网站`}
              allowClear
              options={accountWebsiteOptions}
              disabled={isEdit}
            />
          </Form.Item>
          <Form.Item
            layout="vertical"
            label="账号/手机号"
            name="account"
            rules={[{ required: true }]}
          >
            <Input placeholder="请输入账号/手机号" allowClear />
          </Form.Item>
          <Form.Item
            layout="vertical"
            label="密码"
            name="password"
            rules={[{ required: true }]}
          >
            <Input.Password placeholder="请输入密码" allowClear />
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
}

export default AccountManagement;
